import React, { useState } from 'react';
import { Form, Input, Button, Row, Col, Card, Space } from 'antd';

const ProbationFeedbackForm = () => {
  const [questions, setQuestions] = useState([
    { id: 1, question: '', options: [''] },
  ]);

  const addQuestion = () => {
    const newQuestion = {
      id: questions.length + 1,
      question: '',
      options: [''],
    };
    setQuestions([...questions, newQuestion]);
  };

  const addOption = (questionId) => {
    const updatedQuestions = questions.map((q) =>
      q.id === questionId
        ? { ...q, options: [...q.options, ''] }
        : q
    );
    setQuestions(updatedQuestions);
  };

  return (
    <Card title="Probation Feedback Form" style={{ maxWidth: 900, margin: '0 auto' }}>
      <Form layout="vertical">
        {questions.map((q) => (
          <Card
            key={q.id}
            style={{ marginBottom: 20 }}
            title={`Question ${q.id}`}
          >
            <Form.Item label="Question" required>
              <Input.TextArea
                placeholder="Enter question"
                autoSize={{ minRows: 2, maxRows: 6 }}
              />
            </Form.Item>

            <Row gutter={16}>
              {q.options.map((option, index) => (
                <Col span={12} key={index}>
                  <Form.Item label={`Option ${index + 1}`} required>
                    <Input placeholder="Enter option" />
                  </Form.Item>
                </Col>
              ))}
            </Row>

            <Button type="dashed" onClick={() => addOption(q.id)}>
              Add Option
            </Button>
          </Card>
        ))}

        <Space>
          <Button type="primary" onClick={addQuestion}>
            Add Question
          </Button>
          <Button type="default" htmlType="submit">
            Submit
          </Button>
        </Space>
      </Form>
    </Card>
  );
};

export default ProbationFeedbackForm;
